
document.addEventListener('DOMContentLoaded', function () {

    function observeHeight() {
        setTimeout(() => {
            $('.table_head .first_td_list .table_td').css('height', 'auto');
            let td_lenght = $('.table_head .first_td_list .table_td').length;
            for (let index = 0; index < td_lenght; index++) {
                let maxHeight = 0;
                $(`.reward_tiers_box .table_td[data-index=${index + 1}]`).each(function (index, item) {
                    if ($(item).innerHeight() > maxHeight) {
                        maxHeight = $(item).innerHeight();
                    }
                });
                $(`.reward_tiers_box .table_td[data-index=${index + 1}]`).innerHeight(maxHeight + 'px');
            }
        }, 0);
    }
    observeHeight();
    $(window).resize(function () {
        observeHeight();
    })
});
